import React from 'react';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-16 bg-slate-900 text-white" data-id="element-118">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-119">
        <div className="text-center mb-8 md:mb-10" data-id="element-120">
          <h2 className="font-display text-2xl md:text-4xl font-bold mb-2" data-id="element-121">
            GARANTÍA
          </h2>
          <p className="text-sm md:text-base text-slate-400" data-id="element-122">
            Tu compra está 100% protegida
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-123">
          <div className="flex md:flex-col items-center md:text-center gap-4 md:gap-0 p-4 md:p-6 bg-slate-800/50 rounded-xl md:rounded-2xl border border-slate-700" data-id="element-124">
            <Zap className="w-10 h-10 md:w-12 md:h-12 md:mb-4 text-amber-400 flex-shrink-0" data-id="element-125" />
            <div data-id="element-126">
              <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2" data-id="element-127">
                Acceso inmediato
              </h3>
              <p className="text-xs md:text-sm text-slate-400" data-id="element-128">
                Recibís todo el material apenas realizás el pago.
              </p>
            </div>
          </div>
          <div className="flex md:flex-col items-center md:text-center gap-4 md:gap-0 p-4 md:p-6 bg-slate-800/50 rounded-xl md:rounded-2xl border border-slate-700" data-id="element-129">
            <Lock className="w-10 h-10 md:w-12 md:h-12 md:mb-4 text-emerald-400 flex-shrink-0" data-id="element-130" />
            <div data-id="element-131">
              <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2" data-id="element-132">
                Pago seguro
              </h3>
              <p className="text-xs md:text-sm text-slate-400" data-id="element-133">
                Transacción 100% encriptada y segura.
              </p>
            </div>
          </div>
          <div className="flex md:flex-col items-center md:text-center gap-4 md:gap-0 p-4 md:p-6 bg-slate-800/50 rounded-xl md:rounded-2xl border border-slate-700" data-id="element-134">
            <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 md:mb-4 text-blue-400 flex-shrink-0" data-id="element-135" />
            <div data-id="element-136">
              <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2" data-id="element-137">
                Garantía de 7 días
              </h3>
              <p className="text-xs md:text-sm text-slate-400" data-id="element-138">
                Si no es lo que esperabas, te devolvemos el 100%.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}